<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import { EventBus, sendMessage } from '@/websocket'

/**
 * Starter page component
 */
export default {
  page() {
    return {
      title: this.title,
      meta: [{ name: "description" }],
    };
  },
  components: { Layout, PageHeader },
  data() {
    return {
      title: "",
      items: [],
      loading: false,
      messagelist: [],
      page: 1,
      userinfo: [],
      limit: 20,
      messagetotal: 0,
      cardport: "",
    };
  },
  created() {
    // 监听全局 EventBus
    EventBus.$on('ws-message', this.handleMessage)
  },
  beforeDestroy() {
    // 防止内存泄漏
    EventBus.$off('ws-message', this.handleMessage)
  },
  mounted() {
    this.title = this.$t("menuitems.clouds.nfcreader.text");
    this.items = [
      {
        text: this.$t("menuitems.clouds.text"),
        href: "/",
      },
      {
        text: this.$t("menuitems.clouds.nfcreader.text"),
        active: true,
      },
    ];
    this.userinfo = JSON.parse(localStorage.getItem("user"));
    //   this.page.title=this.$t('global.notice.type.notify')
    // this.getnfcreaderlist();
    this.cardport = localStorage.getItem("cardreader") || "";
  },
  methods: {
    getnfcreaderlist() {
      var that = this;
      that.loading = true;
      that.$axios
        .post(
          that.apiuri,
          {
            action: "getcardreaderlist",
          },
          {
            headers: { Openid: that.userinfo.openid },
          }
        )
        .then(function (response) {
          that.loading = false;
          that.messagelist = response.data.data;
          console.log(that.messagelist);
        })
        .catch(function (error) {
          // console.log(error);
        });
    },
    update(sn) {
      this.loading = true;
      this.$axios
        .post(
          this.apiuri,
          {
            action: "cardreadermakeupdate",
            sn,
          },
          {
            headers: { Openid: this.userinfo.openid },
          }
        )
        .then((response) => {
          this.loading = false;
          if (response.data.status === 200) {
            this.$message({
              message: this.$t("menuitems.clouds.nfcreader.command.success"),
              type: "success",
            });
          } else {
            this.$message.error(this.$t("menuitems.clouds.nfcreader.command.fail"));
          }
        })
        .catch((error) => {
          this.loading = false;
          console.error("更新设备失败:", error);
          this.$message.error(this.$t("global.errors.network"));
        });
    },
    handleMessage(msg) {
      this.messagelist = JSON.parse(msg).devices || [];
    },
    getnfcreaderlistv2() {
      this.cardport = localStorage.getItem("cardreader") || "";
      let command = {
        type: "command",
        command: "getlist"
      }
      sendMessage(JSON.stringify(command))
    },
    updatev2(port) {
      this.$confirm(this.$t("menuitems.clouds.nfcreader.tips.update"), this.$t("menuitems.clouds.nfcreader.tips.warning"), {
        confirmButtonText: this.$t("global.button.ok"),
        cancelButtonText: this.$t("global.button.cancel"),
        type: 'warning'
      }).then(() => {
        let command = {
          type: "command",
          command: "update",
          device: port
        }
        sendMessage(JSON.stringify(command))
      });

    },
    disconnect(port) {
      this.$confirm(this.$t("menuitems.clouds.nfcreader.tips.disconnect"), this.$t("menuitems.clouds.nfcreader.tips.warning"), {
        confirmButtonText: this.$t("global.button.ok"),
        cancelButtonText: this.$t("global.button.cancel"),
        type: 'warning'
      }).then(() => {
        let command = {
          type: "command",
          command: "disconnect",
          device: port
        }
        sendMessage(JSON.stringify(command))
      });
    },
    autoconnect() {
      let command = {
        type: "command",
        command: "scan"
      }
      sendMessage(JSON.stringify(command))
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body" v-loading="loading">
            <p>
              <!-- <router-link to="/clouds/nfcreader/add">
                <el-button type="primary">{{
                  $t("menuitems.clouds.nfcreader.bind")
                }}</el-button>
              </router-link> -->
              <el-button type="primary" @click="getnfcreaderlistv2">
                <i class="el-icon-refresh"></i>
                {{ $t("menuitems.clouds.nfcreader.refresh") }}
              </el-button>
              <el-button type="primary" @click="autoconnect">
                <i class="el-icon-search"></i>
                {{ $t("menuitems.clouds.nfcreader.autoconnect") }}
              </el-button>
            </p>
            <el-table :data="messagelist" stripe style="width: 100%">
              <el-table-column prop="port" :label="$t('menuitems.clouds.nfcreader.port')">
              </el-table-column>
              <el-table-column :label="$t('menuitems.clouds.nfcreader.name')">
                <template slot-scope="scope">
                  <span>{{ scope.row.description }}</span>
                </template>
              </el-table-column>
              <el-table-column :label="$t('menuitems.clouds.nfcreader.update')">
                <template slot-scope="scope">
                  <el-button type="primary" @click="updatev2(scope.row.port)">
                    {{ $t("menuitems.clouds.nfcreader.command.update") }}
                  </el-button>
                  <el-button v-if="cardport == scope.row.port" type="warning" @click="disconnect(scope.row.port)">
                    {{ $t("menuitems.clouds.nfcreader.command.disconnect") }}
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>